import { useState } from 'react';
// @mui
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// hooks
import useAuth from '../../hooks/useAuth';
// utils
import axios from '../../utils/axios';
import { FreeToProDialog } from './';

// ----------------------------------------------------------------------

export default function FreeCoffeeChatDialogButton({
  buttonTitle = "커피챗 제안하기",
  sx = {},
  buttonSource="try-coffee",
  buttonVariant="contained",
}) {
  const [open, setOpen] = useState(false);
  const containedButton = buttonVariant === "contained";

  return (
    <>
    <Stack spacing={1} sx={{ width: 1, mt: 3, ...sx }}>
      <Box>
        <LoadingButton
          sx={{
            px: 2,
            ...!containedButton && {
              color: "text.secondary",
              borderColor: "#919EAB52",
            },
          }}
          variant={buttonVariant}
          size="medium"
          onClick={() => setOpen(true)}
          color={containedButton ? "primary" : "inherit"}
          disableRipple
        >
          {buttonTitle}
        </LoadingButton>
      </Box>
    </Stack>
    <FreeToProDialog open={open} closeDialog={() => setOpen(false)} buttonSource={buttonSource} />
    </>
  )
};
